import { render, staticRenderFns } from "./MoreProjectsComponent.vue?vue&type=template&id=4e4dd5a4&scoped=true&"
import script from "./MoreProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./MoreProjectsComponent.vue?vue&type=script&lang=js&"
import style0 from "./MoreProjectsComponent.vue?vue&type=style&index=0&id=4e4dd5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4dd5a4",
  null
  
)

export default component.exports